import React from 'react';
import Dialog from 'components/DesignSystem/Dialog';
import SavePreferenceForm from './SavePreferenceForm';

import './index.scss';

export default function FormModal({
  show,
  valid,
  isLoading,
  onHide,
  onNameChange,
  handleSubmit,
}: {
  show: boolean;
  valid: boolean;
  isLoading: boolean;
  onHide: () => void;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
}) {
  return (
    <Dialog
      open={show}
      dismiss={onHide}
      closeButton
    >
      <Dialog.Body>
        <SavePreferenceForm
          valid={valid}
          isLoading={isLoading}
          onNameChange={onNameChange}
          handleSubmit={handleSubmit}
        />
      </Dialog.Body>
    </Dialog>
  );
}
